import { render, staticRenderFns } from "./CopyCourses.vue?vue&type=template&id=6c902c31&scoped=true&"
import script from "./CopyCourses.vue?vue&type=script&lang=js&"
export * from "./CopyCourses.vue?vue&type=script&lang=js&"
import style0 from "./CopyCourses.vue?vue&type=style&index=0&id=6c902c31&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c902c31",
  null
  
)

export default component.exports